import { CONFIG } from './config.js';

// 初始化编辑器
function initEditor() {
    const editor = CodeMirror.fromTextArea(document.getElementById('editor'), {
        mode: 'htmlmixed',
        theme: CONFIG.editor.theme,
        lineNumbers: true,
        autoCloseTags: true,
        autoCloseBrackets: true,
        matchTags: true,
        matchBrackets: true,
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
        extraKeys: {
            'Ctrl-Space': 'autocomplete',
            'Ctrl-/': 'toggleComment',
            'Ctrl-Q': function(cm) {
                cm.foldCode(cm.getCursor());
            },
            'Alt-F': 'foldAll',
            'Alt-U': 'unfoldAll'
        },
        lineWrapping: true,
        indentUnit: CONFIG.editor.indentUnit,
        tabSize: CONFIG.editor.tabSize,
        indentWithTabs: false,
        placeholder: CONFIG.editor.placeholder,
        foldOptions: {
            widget: '...',
            scanUp: false,
            minFoldSize: 3
        },
        fold: 'indent',
    });

    // 设置默认的HTML代码
    editor.setValue(CONFIG.defaultCode);

    // 添加折叠所有代码的命令
    CodeMirror.commands.foldAll = function(cm) {
        cm.operation(function() {
            for (let i = cm.firstLine(); i <= cm.lastLine(); i++) {
                cm.foldCode(CodeMirror.Pos(i, 0));
            }
        });
    };

    // 添加展开所有代码的命令
    CodeMirror.commands.unfoldAll = function(cm) {
        cm.operation(function() {
            for (let i = cm.firstLine(); i <= cm.lastLine(); i++) {
                cm.foldCode(CodeMirror.Pos(i, 0), null, 'unfold');
            }
        });
    };

    return editor;
}

// 导出编辑器功能
export {
    initEditor
}; 